/**
 * @file    CreditsValueTable.jsx - Exports a function that renders a table component of DCCs and
 *                                  dollar amounts.
 * @author  Kirill Kirnichansky <kirill@distributive.network>
 * @date    Oct. 2022
 */

const { VITE_ASSETS_PATH } = import.meta.env;

export const CreditsValueTable = (_props) => {
  const creditRangeValues = [
    { min: '0.199', max: ' ', value: 0, least: true },
    { min: '0.200', max: '0.399', value: 1, dash: true },
    { min: '0.400', max: '0.599', value: 2, dash: true },
    { min: '0.600', max: '0.799', value: 3, dash: true },
    { min: '0.800', max: '0.999', value: 4, dash: true },
    { min: '1.000', value: 5 },
  ]
  
  return (
    <div id="smith_rs_workerTable" className="card">
      <p>
        Your Contributor account is used to store the credits you generate
        when your computer is used to complete scientists' calculations.
        You can refer to the table below to determine the current dollar amount
        of your credits.
      </p>
      <table id="smith_rs_creditsValueTable">
        <thead>
          <tr>
            <th id="smith_rs_creditsHeader">
              Credits (<img src={`${VITE_ASSETS_PATH}/img/credits.png`} alt="Credits icon"/>)
            </th>
            <th>Amount (USD)</th>
          </tr>
        </thead>
        <tbody>
          {creditRangeValues.map(({min, max, value, dash, least}) => {
            return (
              <tr key={value}>
                <td className="smith_rs_tableCreditsCell">
                  {min}
                  {dash ? (
                    <>
                      <span className="smith_rs_tableDash">&mdash;</span>
                    </> 
                  ) : (
                    <>&nbsp;</>
                  )}
                  {least ? (
                    <span id="smith_rs_orLessTxt">or less...</span>
                  ) : (
                    <></>
                  )}
                  {max ? (
                    <>
                      {max}
                    </>
                  ) : (
                    <span id="smith_rs_orMoreTxt">or more...</span>
                  )}
                </td>
                <td className="smith_rs_tableAmountVal">{value.toFixed(2)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
